import { lobbyLabel } from "../shared/lobby";
import { playerColorForSlot } from "../shared/playerNameColor";
import type { LobbyPlayer } from "../shared/types";

export type PlayerSlotModel = {
  slot: number;
  label: string;
  open: boolean;
  local: boolean;
  displayName: string;
  characterId: string;
  characterName: string;
  color: string;
  ready: boolean;
  inMatch: boolean;
  waiting: boolean;
};

export const STAT_PIPS = 5;

export function statPips(value: number, min: number, max: number, pips = STAT_PIPS): number {
  if (!Number.isFinite(value)) return 1;
  if (max <= min) return Math.ceil(pips / 2);
  const ratio = Math.min(1, Math.max(0, (value - min) / (max - min)));
  return 1 + Math.round(ratio * (pips - 1));
}

export function slotGrid(count: number, perRow = 5): { cols: number; rows: number } {
  const total = Math.max(1, count);
  const rows = Math.ceil(total / perRow);
  return { cols: Math.ceil(total / rows), rows };
}

export function buildPlayerSlots(options: {
  players: readonly LobbyPlayer[];
  localPlayerId: string | null;
  localWaiting: boolean;
  preview: { displayName: string; characterId: string; characterName: string };
  characterName: (characterId: string) => string;
}): PlayerSlotModel[] {
  if (options.players.length === 0) {
    return [
      {
        slot: 0,
        label: lobbyLabel(0),
        open: false,
        local: true,
        displayName: options.preview.displayName || "Player 1",
        characterId: options.preview.characterId,
        characterName: options.preview.characterName,
        color: playerColorForSlot(0),
        ready: false,
        inMatch: false,
        waiting: false
      }
    ];
  }

  return options.players
    .slice()
    .sort((first, second) => first.slot - second.slot)
    .map((player) => {
      const local = player.id === options.localPlayerId;
      return {
        slot: player.slot,
        label: lobbyLabel(player.slot),
        open: false,
        local,
        displayName: local && options.preview.displayName ? options.preview.displayName : player.displayName,
        characterId: player.characterId,
        characterName: options.characterName(player.characterId),
        color: player.color,
        ready: player.ready,
        inMatch: player.inMatch,
        waiting: local && options.localWaiting
      };
    });
}
